import DoNotSellForm from '@/apps/doNotSell/DoNotSellForm.vue';

const doNotSellRoutes = [
  {
    path: '/do-not-sell-my-personal-information',
    name: 'doNotSell',
    component: DoNotSellForm,
  },
];

export default doNotSellRoutes;
